import { useEffect } from "react"

import { Layout, Spin, Typography } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useLocation } from "react-router"

import LoginHeader from "../Components/LoginHeader"
import { RoutesPaths } from "../constants/user-routes"
import { useQuery } from "../Utils/utils"
import { confirmEmail, socialAuth } from "./LoginPage/redux/auth.thunks"

import "./CheckEmailCode.less"

const { Text } = Typography

export const OAUTH_CONFIG = {
  shopify: {
    title: "Shopify Auth - Chargeback",
    confirmationText: "Shopify confirmation",
    paramKey: "shop",
    successfulRedirectPath: RoutesPaths.configure.processors
  },
  stripe: {
    title: "Stripe Auth - Chargeback",
    confirmationText: "Stripe confirmation",
    paramKey: "account_id",
    successfulRedirectPath: RoutesPaths.configure.processors
  },
  nextcommerce: {
    title: "NextCommerce Auth - Chargeback",
    confirmationText: "NextCommerce confirmation",
    paramKey: "store",
    additionalParamKeys: ["email"],
    successfulRedirectPath: RoutesPaths.configure.processors
  }
}

const OAuthAuthPage = ({ socialAuth, accessToken, userInfo, fetching, provider }) => {
  const { search } = useLocation()
  const { t } = useTranslation()

  let query = useQuery(search)
  const config = OAUTH_CONFIG[provider]

  if (!config) {
    console.error(`OAuth provider "${provider}" not supported`)
    return null
  }

  const paramValue = query.get(config.paramKey)
  const businessAccountIdFromQuery = query.get("business_account_id")

  useEffect(() => {
    document.title = config.title
    const additionalParams = {}
    if (config.additionalParamKeys) {
      config.additionalParamKeys.forEach((key) => {
        const value = query.get(key)
        if (value) {
          additionalParams[key] = value
        }
      })
    }
    if (paramValue) {
      socialAuth({
        ...additionalParams,
        [config.paramKey]: paramValue,
        accessToken,
        business_account_id: businessAccountIdFromQuery || userInfo?.current_business_account_id,
        successfulRedirectPath: config.successfulRedirectPath
      })
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  return (
    <Layout>
      <div className="login-row">
        <LoginHeader />

        <Spin spinning={fetching}>
          <div className="login-content check-email-code">
            <div className="page-content">
              <Text type="secondary">{t(config.confirmationText)}</Text>
            </div>
          </div>
        </Spin>
      </div>
    </Layout>
  )
}

OAuthAuthPage.propTypes = {
  socialAuth: PropTypes.func.isRequired,
  accessToken: PropTypes.string,
  userInfo: PropTypes.object,
  fetching: PropTypes.bool,
  provider: PropTypes.oneOf(["shopify", "stripe", "nextcommerce"]).isRequired
}

const mapStateToProps = (state) => ({
  fetching: state?.auth?.fetching,
  accessToken: state.auth.accessToken,
  userInfo: state.auth.userInfo
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  confirmEmail: (hash, redirect) => dispatch(confirmEmail({ hash, redirect })),
  socialAuth: (data) => dispatch(socialAuth({ accessToken: data, socialType: ownProps.provider }))
})

export default connect(mapStateToProps, mapDispatchToProps)(OAuthAuthPage)
